import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import TransferOutTrackingReportActions, {
  TransferOutTrackingReportTypes
} from '../Stores/TransferOutTrackingReport/Actions';

const getAppStore = state => state.app;

export function* transferOutTrackingReportInitTransferOutTracking() {
  try {
    yield put(TransferOutTrackingReportActions.transferOutTrackingReportReportLoading(true));

    const app = yield select(getAppStore);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `stkTrfReport/initTransferOutTracking/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(
        TransferOutTrackingReportActions.transferOutTrackingReportInitTransferOutTrackingSuccess(
          result.data
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(TransferOutTrackingReportActions.transferOutTrackingReportReportLoading(false));
  }
}

export function* transferOutTrackingReportTransferOutTracking({ formikBag, criteria }) {
  try {
    formikBag.setSubmitting(true);
    yield put(TransferOutTrackingReportActions.transferOutTrackingReportReportLoading(true));

    const objCriteria = {};
    if ('start_date' in criteria) {
      objCriteria.start_date = criteria.start_date;
    }
    if ('end_date' in criteria) {
      objCriteria.end_date = criteria.end_date;
    }
    if ('division_ids_select2' in criteria) {
      const values = criteria.division_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.division_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('to_location_ids_select2' in criteria) {
      const values = criteria.to_location_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.to_location_ids = values.map(entry => {
          return entry.value;
        });
      }
    }
    if ('transport_ids_select2' in criteria) {
      const values = criteria.transport_ids_select2;
      if (values !== null && values.length > 0) {
        objCriteria.transport_ids = values.map(entry => {
          return entry.value;
        });
      }
    }

    let columns = [];
    if (criteria.columns.target.length > 0) {
      columns = criteria.columns.target.map(entry => {
        return entry.column;
      });
    }

    const app = yield select(getAppStore);
    const postData = {
      sorts: [],
      criteria: objCriteria,
      columns
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `stkTrfReport/transferOutTracking/${app.curSiteFlowId}`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(
        TransferOutTrackingReportActions.transferOutTrackingReportTransferOutTrackingSuccess(
          criteria,
          result.data.data
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
    yield put(TransferOutTrackingReportActions.transferOutTrackingReportReportLoading(false));
  }
}

export function* transferOutTrackingReportFetchDivisionOptions({ search }) {
  try {
    yield put(
      TransferOutTrackingReportActions.transferOutTrackingReportFetchDivisionOptionLoading(true)
    );

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `division/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.name_01}`
      }));

      yield put(
        TransferOutTrackingReportActions.transferOutTrackingReportFetchDivisionOptionSuccess(
          options
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      TransferOutTrackingReportActions.transferOutTrackingReportFetchDivisionOptionLoading(false)
    );
  }
}

export function* transferOutTrackingReportFetchToLocationOptions({ search }) {
  try {
    yield put(
      TransferOutTrackingReportActions.transferOutTrackingReportFetchToLocationOptionLoading(true)
    );

    const app = yield select(getAppStore);
    const postData = {
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `location/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01}`
      }));

      yield put(
        TransferOutTrackingReportActions.transferOutTrackingReportFetchToLocationOptionSuccess(
          options
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      TransferOutTrackingReportActions.transferOutTrackingReportFetchToLocationOptionLoading(false)
    );
  }
}

export function* transferOutTrackingReportFetchTransportOptions({ search }) {
  try {
    yield put(
      TransferOutTrackingReportActions.transferOutTrackingReportFetchTransportOptionLoading(true)
    );

    const app = yield select(getAppStore);
    const postData = {
      siteFlowId: app.curSiteFlowId,
      search,
      filters: []
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `transport/select2`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      const options = result.data.data.map(d => ({
        value: d.id,
        label: `${d.code} ${d.desc_01} ${d.desc_02}`
      }));

      yield put(
        TransferOutTrackingReportActions.transferOutTrackingReportFetchTransportOptionSuccess(
          options
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(
      TransferOutTrackingReportActions.transferOutTrackingReportFetchTransportOptionLoading(false)
    );
  }
}

export const saga = [
  takeLatest(
    TransferOutTrackingReportTypes.TRANSFER_OUT_TRACKING_REPORT_INIT_TRANSFER_OUT_TRACKING,
    transferOutTrackingReportInitTransferOutTracking
  ),
  takeLatest(
    TransferOutTrackingReportTypes.TRANSFER_OUT_TRACKING_REPORT_TRANSFER_OUT_TRACKING,
    transferOutTrackingReportTransferOutTracking
  ),

  takeLatest(
    TransferOutTrackingReportTypes.TRANSFER_OUT_TRACKING_REPORT_FETCH_DIVISION_OPTIONS,
    transferOutTrackingReportFetchDivisionOptions
  ),
  takeLatest(
    TransferOutTrackingReportTypes.TRANSFER_OUT_TRACKING_REPORT_FETCH_TO_LOCATION_OPTIONS,
    transferOutTrackingReportFetchToLocationOptions
  ),

  takeLatest(
    TransferOutTrackingReportTypes.TRANSFER_OUT_TRACKING_REPORT_FETCH_TRANSPORT_OPTIONS,
    transferOutTrackingReportFetchTransportOptions
  )
];
